export enum Currency {
  EUR = 'EUR',
  CHF = 'CHF',
  ISK = 'ISK',
  CZK = 'CZK',
  AED = 'AED',
}
